module.exports = __webpack_public_path__ + "img/arrow-next.dc50d85a.svg";